module.exports = __webpack_public_path__ + "img/GH.6ad2b9cb.svg";